// istanbul ignore file

import { ServiceCode } from '../utils/service-id-mapper';

enum ServiceShortName {
    Smoke = ServiceCode.SMOKE,
    Gas = ServiceCode.GAS,
    Electrical = ServiceCode.ELECTRICAL,
    CordedBlinds = ServiceCode.CORDED_BLINDS,
    MinimumStandards = ServiceCode.MINIMUM_STANDARDS
}

export { ServiceShortName };
